import styled from '@emotion/styled/macro';

import StatusMessageWithIcon from '../../../StatusMessageWithIcon/StatusMessageWithIcon';

export const StyledStatusMessageWithIcon = styled(StatusMessageWithIcon)`
  margin-top: 1.5rem;
`;
